export default __webpack_public_path__ + "static/media/onboard_new_plant_black.0200af28.svg";